import {
  setInterviewExperience,
  setAllInterviewExperiences,
  setAllDraftInterviewExperiences,
  setInterviewExperienceChat,
} from '../../slices/interviewExperiencesSlice';
import { interviewExperienceEndpoints } from '../api';
import toast from 'react-hot-toast';
import { apiConnector } from '../apiConnector';

const {
  DELETE_INTERVIEW_EXPERIENCE,
  GET_ALL_INTERVIEW_EXPERIENCES,
  GET_ALL_DRAFT_INTERVIEW_EXPERIENCES,
  GET_SINGLE_DRAFT_INTERVIEW_EXPERIENCE,
  DELETE_DRAFT_INTERVIEW_EXPERIENCE,
  GET_INTERVIEW_EXPERIENCE_BY_ID,
  UPDATE_INTERVIEW_EXPERIENCE,
  TOGGLE_ISAPPROVED_INTERVIEW_EXPERIENCE,
  ADD_COMMENTS_MESSAGE,
  GET_COMMENTS_MESSAGE,
  MOVE_TO_PUBLISHED,
  UPDATE_INTERVIEW_EXPERIENCE_STATUS,
  UPDATE_DRAFT_INTERVIEW_EXPERIENCE,
} = interviewExperienceEndpoints;

export function getAllInterviewExperiences() {
  return async (dispatch) => {
    try {
      const response = await apiConnector('GET', GET_ALL_INTERVIEW_EXPERIENCES);

      if (response?.data.success) {
        dispatch(setAllInterviewExperiences(response.data.data));
      } else {
        console.warn('No data found in the response');
      }
    } catch (error) {
      console.error('Error fetching interview experiences:', error);
      toast.error('Failed to fetch interview experiences');
    }
  };
}

export function getAllDraftInterviewExperiences() {
  return async (dispatch) => {
    try {
      const response = await apiConnector('GET', GET_ALL_DRAFT_INTERVIEW_EXPERIENCES);

      if (response?.data.success) {
        dispatch(setAllDraftInterviewExperiences(response.data.data));
      } else {
        console.warn('No draft data found in the response');
      }
    } catch (error) {
      console.error('Error fetching draft interview experiences:', error);
      toast.error('Failed to fetch draft interview experiences');
    }
  };
}

export function getInterviewExperiences(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('GET', GET_INTERVIEW_EXPERIENCE_BY_ID + `${id}`);
      if (response?.data.success) {
        dispatch(setInterviewExperience(response.data.data));
      } else {
        console.warn('No data found in the response');
      }
    } catch (error) {
      console.error('Error fetching interview experiences:', error);
      toast.error('Failed to fetch interview experiences');
    }
  };
}

export function toggleIsApproved(id, setIsApproved) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('POST', TOGGLE_ISAPPROVED_INTERVIEW_EXPERIENCE + `${id}`);

      if (response?.data.success) {
        toast.success('Successfully Toggle IsApproved');
        setIsApproved((prev) => !prev);
        dispatch(getAllInterviewExperiences());
      } else {
        toast.error('Failed to Toggle IsApproved');
      }
    } catch (error) {
      console.error('Error toggling isApproved:', error);
      toast.error(error?.response?.data?.error || 'Failed to Toggle IsApproved');
    }
  };
}

export function deleteExperienceDetails(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('DELETE', DELETE_INTERVIEW_EXPERIENCE + `${id}`);
      if (response?.data.success) {
        toast.success('Successfully Deleted Interview Experience');
        dispatch(getAllInterviewExperiences());
      } else {
        toast.error('Failed to Delete Interview Experience');
      }
    } catch (error) {
      console.error('Error fetching interview experiences:', error);
      toast.error('Failed to fetch interview experiences');
    }
  };
}

export function updateInterviewExperience (id, data, isAnonymous, setLoading, navigate) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('PUT', UPDATE_INTERVIEW_EXPERIENCE + `${id}`, {
        data,
        isAnonymous,
      });
      if (response?.data.success) {
        toast.success('Successfully Updated Interview Experience');
        dispatch(getAllInterviewExperiences());
        navigate(`/interview/all-interview-experiences?tab=published`);
      } else {
        toast.error(response?.data?.message || 'Failed to Update Interview Experience');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to Update Interview Experience');
    } finally {
      dispatch(getInterviewExperiences(id));
      setLoading(false);
    }
  };
}

export function deleteDraftExperienceDetails(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('DELETE', DELETE_DRAFT_INTERVIEW_EXPERIENCE + `${id}`);
      if (response?.data.success) {
        toast.success('Successfully Deleted Draft Interview Experience');
        dispatch(getAllDraftInterviewExperiences());
      } else {
        toast.error('Failed to Delete Draft Interview Experience');
      }
    } catch (error) {
      console.error('Error deleting draft interview experience:', error);
      toast.error('Failed to delete draft interview experience');
    }
  };
}

export function moveDraftToPublished(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('POST', MOVE_TO_PUBLISHED + `${id}`);
      if (response?.data.success) {
        toast.success('Successfully moved draft to published');
        // Refresh both lists
        dispatch(getAllDraftInterviewExperiences());
        dispatch(getAllInterviewExperiences());
      } else {
        toast.error('Failed to move draft to published');
      }
    } catch (error) {
      console.error('Error moving draft to published:', error);
      toast.error('Failed to move draft to published');
    }
  };
}

export function getSingleDraftInterviewExperience(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('GET', GET_SINGLE_DRAFT_INTERVIEW_EXPERIENCE + `${id}`);
      if (response?.data.success) {
        dispatch(setInterviewExperience(response.data.data));
        dispatch(setInterviewExperienceChat(response.data.data.comments));
      } else {
        console.warn('No draft data found in the response');
      }
    } catch (error) {
      console.error('Error fetching single draft interview experience:', error);
      toast.error('Failed to fetch draft interview experience');
    }
  };
}

export function updateDraftExperienceStatus(id, status) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('PUT', UPDATE_INTERVIEW_EXPERIENCE_STATUS + `${id}`, {
        status
      });
      if (response?.data.success) {
        toast.success('Successfully Updated Status');
        dispatch(getAllDraftInterviewExperiences());
      } else {
        toast.error('Failed to Update Status');
      }
    } catch (error) {
      console.error('Error updating draft status:', error);
      toast.error('Failed to update status');
    }
  };
}

export function updateDraftInterviewExperience(id, data, navigate) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('PUT', UPDATE_DRAFT_INTERVIEW_EXPERIENCE + `${id}`, {data});
      if (response?.data.success) {
        toast.success('Successfully Updated Draft Interview Experience');
        dispatch(getAllDraftInterviewExperiences());
        navigate(`/interview/all-interview-experiences?tab=draft`);
      } else {
        toast.error('Failed to Update Draft Interview Experience');
      }
    } catch (error) {
      console.error('Error updating draft interview experience:', error);
      toast.error('Failed to update draft interview experience');
    }
  };
}

export function getCommentsMessage(id) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('GET', GET_COMMENTS_MESSAGE + `${id}`);
      if (response?.data.success) {
        dispatch(setInterviewExperienceChat(response.data.data));
      } else {
        console.warn('No data found in the response');
      }
    } catch (error) {
      console.error('Error fetching comments message:', error);
      toast.error('Failed to fetch comments message');
    }
  }
} 


export function addCommentsMessage(id, comments) {
  return async (dispatch) => {
    try {
      const response = await apiConnector('PUT', ADD_COMMENTS_MESSAGE + `${id}`, {comments});
      if (response?.data.success) {
        toast.success('Successfully Added Comments Message');
        dispatch(getCommentsMessage(id));
      } else {
        toast.error('Failed to Add Comments Message');
      }
    } catch (error) {
      console.error('Error adding comments message:', error);
      toast.error('Failed to add comments message');
    }
  };  
}
